import React from 'react';
import { useHistory } from 'react-router-dom';

import iconFilterX from './images/icon-filter-x.svg';
import { replaceAllComplex } from '../../../../../../mol_function';
import { FilerTranslateItem } from '.';

interface FilterResultItemProp {
  item: FilerTranslateItem;
  value: string;
  delAction: (
    item: FilerTranslateItem,
    value: string,
    historyHandle: any,
  ) => void;
}

export default function FilterResultItem(props: FilterResultItemProp) {
  let history = useHistory();

  let value = replaceAllComplex(props.value, [
    { s: '+', r: ' ' },
    { s: '%2F', r: '/' },
    { s: '%2C', r: ',' },
    { s: '___', r: '/' },
    { s: '_', r: ' ' },
    { s: '%3F', r: '?' },
    { s: 'amp;', r: '&' },
    { s: '%26', r: '&' },
    { s: '%3A', r: ':' },
  ]);

  let valuePart = null;
  if (props.item.mode != 'custom') {
    valuePart = (
      <React.Fragment>
        : <span>{value}</span>
      </React.Fragment>
    );
  }

  return (
    <a
      className="FilterResultItem"
      onClick={() => {
        props.delAction(props.item, props.value, history);
      }}
      title={'Filter ' + props.item.caption + ' entfernen'}
    >
      {props.item.caption}
      {valuePart}
      <img
        src={iconFilterX}
        className="delIcon"
        style={{ paddingLeft: '3px' }}
      />
    </a>
  );
}
